module.exports = __webpack_public_path__ + "img/Conveyor-1200-COMPRESSED.34c88329.gif";